import { type User } from "@microsoft/microsoft-graph-types";
import { isDefined } from "@repo/utils";

import * as fetcher from "../fetcher";

const adminGroup = import.meta.env.VITE__AZ_ADMIN_GROUP;
const defaultSelect =
  "displayName,mail,surname,givenName,officeLocation,onPremisesExtensionAttributes";

const getGlobalUsers = async (
  searchTerm: string,
  groupId: string,
  select?: string // return specific fields
): Promise<User[]> =>
  fetcher.coworker.post<User[], false>("/graph/search/global/user", {
    adminGroupId: groupId,
    searchTerm,
    select: select ?? defaultSelect,
  });

const getUsers = async (searchTerm: string, select?: string): Promise<User[]> =>
  fetcher.coworker.post<User[], false>("/graph/search/user", {
    searchTerm,
    select: select ?? defaultSelect,
  });

export const searchMarketCoworkers = async (
  searchTerm: string
): Promise<User[]> => {
  const requests = [
    getUsers(searchTerm),
    adminGroup ? getGlobalUsers(searchTerm, adminGroup) : undefined,
  ].filter(isDefined);

  const res = await Promise.allSettled(requests).then((results) =>
    results
      .flatMap((r) => {
        if (r.status === "fulfilled") {
          return r?.value;
        }
        return undefined;
      })
      .filter(isDefined)
  );

  return dedupeUsers(res);
};

function dedupeUsers(allUsers: User[]) {
  const dedupeSet = new Set<string>();

  const result: User[] = [];

  for (const user of allUsers) {
    if (!user.mail) {
      result.push(user);
      continue;
    }
    if (!dedupeSet.has(user.mail)) {
      result.push(user);
      dedupeSet.add(user.mail);
    }
  }

  return result;
}
